/**
 * @generated SignedSource<<9f07bbaeba931a2dbb235a0ac720ded7>>
 * @relayHash e581ffa9631cb1e655ff9bbc7de6bb54
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5d63822193e91ba43ff49d6a2eca067b94e210af6f6fe6d015557fbe99c6d171

import type { ConcreteRequest } from 'relay-runtime';
export type SameFileNameWarningFlagQuery$variables = {
  contentId: string;
  status?: ReadonlyArray<string | null> | null;
};
export type SameFileNameWarningFlagQuery$data = {
  readonly content: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly attachments: {
          readonly nodes: ReadonlyArray<{
            readonly extensions: ReadonlyArray<{
              readonly key: string | null;
              readonly value: string | null;
            } | null> | null;
            readonly id: string | null;
            readonly title: string | null;
          } | null> | null;
        } | null;
        readonly id: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type SameFileNameWarningFlagQuery = {
  response: SameFileNameWarningFlagQuery$data;
  variables: SameFileNameWarningFlagQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": [
      "current"
    ],
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "ContentEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "concreteType": "PaginatedContentList",
                "kind": "LinkedField",
                "name": "attachments",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "title"
                      },
                      {
                        "concreteType": "KeyValueHierarchyMap",
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "value"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SameFileNameWarningFlagQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SameFileNameWarningFlagQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e581ffa9631cb1e655ff9bbc7de6bb54",
    "id": "5d63822193e91ba43ff49d6a2eca067b94e210af6f6fe6d015557fbe99c6d171",
    "metadata": {},
    "name": "SameFileNameWarningFlagQuery",
    "operationKind": "query",
    "text": "query SameFileNameWarningFlagQuery($contentId:ID!,$status:[String]=[\"current\"]){content(id:$contentId,status:$status){edges{node{id,attachments{nodes{id,title,extensions{key,value}}}}}}}"
  }
};
})();

(node as any).hash = "1a2b1f8fba4b4d8d2666f06755932652";

export default node;
